import { Component, Input } from '@angular/core';
import type { AddressLabelModel } from './address-label.model';

@Component({
  selector: 'app-address-label-print',
  standalone: false,
  templateUrl: './address-label-print.component.html',
  styleUrl: './address-label-print.component.scss'
})
export class AddressLabelPrintComponent {
  @Input() label: AddressLabelModel | null = null;

  safe(value: string | undefined | null): string {
    return value != null && String(value).trim() !== '' ? String(value).trim() : '';
  }

  get cityStateZip(): string {
    const l = this.label;
    if (!l) return '';
    const parts = [this.safe(l.city), this.safe(l.state), this.safe(l.zipCode)].filter(Boolean);
    return parts.join(', ');
  }

  get idDisplay(): string {
    const l = this.label;
    if (!l) return '';
    const id = this.safe(l.patientId ?? l.accountNumber);
    return id ? `Acct #: ${id}` : '';
  }
}
